'use strict';

customerZone

.component('autocomplete', {
    bindings: {
        options: '=',
        field: '@',
        filterFunction: '<',
        theId: '@',
        label: '@',
        ngModel: '=',
        ngChange: '=',
        imagesPath: '<'
    },
    templateUrl: customerZone.fromBase('components/autocomplete/autocomplete.component.html'),
    controller: ['$timeout', 'config', '$element', function($timeout, config, $element){
        var vm = this;
        var $elem;

        vm.$postLink = function(){

            $elem = $($element.find('input'));
            $elem.keyboardNavigation({
                currentIdx: function() { return vm.selectedIdx; },
                allowedRange: function() { return vm.filtered ? [0, vm.filtered.length-1] : undefined; },
                select: function(idx) { $timeout(function(){ vm.select(idx); }); },
                complete: function() { $timeout(function(){ vm.closePopup(); }); },
                type: function($field) {
                    $timeout(function(){
                        var filterValue = $field.val();
                        if (filterValue === '') vm.filtered = undefined;
                        else vm.filtered = getSuggestions(filterValue);
                    });
                },
                reset: function() {
                    $timeout(function(){ vm.resetField(); });
                }
            });

            function getSuggestions(value){
                return limit(Object.entries(vm.options).filter(vm.filterFunction(value)), 10);
            }

            function limit(list, count){
                if (list.length <= count) return list;
                return list.slice(0, count);
            }
        };

        vm.select = function(idx){
            var selected = vm.filtered[idx][1] || {};
            vm.selectedIdx = idx;
            $elem.val(selected);
            $elem.triggerHandler('input');
            $elem.triggerHandler('change');
        };

        vm.closePopup = function(){
            vm.filtered = undefined;
            vm.selectedIdx = undefined;
        };

        vm.resetField = function(){
            $elem.val('');
            vm.closePopup();
        };

        vm.$onDestroy = function(){
            $elem.keyboardNavigationRemove();
        };
    }],
    controllerAs: 'vm'
});
